export default {"src":"/_next/static/media/text_strip_2.92abe393.svg","height":12,"width":140,"blurWidth":0,"blurHeight":0};